var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "creatTrip_Box" },
    [
      _c(
        "el-dialog",
        {
          staticStyle: { margin: "0 auto", width: "700px" },
          attrs: {
            title: "创建行程",
            width: "65%",
            visible: _vm.createtripAlertState,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "destroy-on-close": true,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.createtripAlertState = $event
            },
            close: _vm.closeCreateTrip,
          },
        },
        [
          _vm.showCreatePlanType
            ? _c(
                "el-radio-group",
                {
                  staticStyle: { "margin-top": "10px" },
                  model: {
                    value: _vm.planCreateType,
                    callback: function ($$v) {
                      _vm.planCreateType = $$v
                    },
                    expression: "planCreateType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("创建行程")]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("文档导入识别"),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("AI创建")]),
                ],
                1
              )
            : _vm._e(),
          _vm.planCreateType == 0 || _vm.planCreateType == 2
            ? _c("div", { staticClass: "createManually" }, [
                _c(
                  "p",
                  [
                    _c("span", [_vm._v("出发日期：")]),
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        size: "small",
                        placeholder: "选择日期",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeTripDate()
                        },
                      },
                      model: {
                        value: _vm.creatTripDate,
                        callback: function ($$v) {
                          _vm.creatTripDate = $$v
                        },
                        expression: "creatTripDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showEndTripDate,
                        expression: "showEndTripDate",
                      },
                    ],
                  },
                  [
                    _c("span", [_vm._v("结束日期：")]),
                    _c("el-date-picker", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        "value-format": "yyyy-MM-dd",
                        type: "date",
                        size: "small",
                        placeholder: "选择日期",
                        "picker-options": _vm.pickerOptions,
                        "default-value": _vm.creatTripDate,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeDate()
                        },
                      },
                      model: {
                        value: _vm.endTripDate,
                        callback: function ($$v) {
                          _vm.endTripDate = $$v
                        },
                        expression: "endTripDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPlanDay,
                        expression: "showPlanDay",
                      },
                    ],
                  },
                  [
                    _c("span", [_vm._v("出行天数：")]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请选择", size: "small" },
                        on: {
                          change: function ($event) {
                            return _vm.changeDate()
                          },
                        },
                        model: {
                          value: _vm.creatTripDays,
                          callback: function ($$v) {
                            _vm.creatTripDays = $$v
                          },
                          expression: "creatTripDays",
                        },
                      },
                      _vm._l(99, function (item) {
                        return _c("el-option", {
                          key: item,
                          attrs: { label: item, value: item },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "p",
                  [
                    _c("span", [_vm._v("预估人数：")]),
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        maxlength: "5",
                        onkeyup: "value=value.replace(/[^\\d]/g,'')",
                        size: "small",
                        placeholder: "请输入预估人数",
                      },
                      model: {
                        value: _vm.useNumber,
                        callback: function ($$v) {
                          _vm.useNumber = $$v
                        },
                        expression: "useNumber",
                      },
                    }),
                  ],
                  1
                ),
                _vm.planCreateType == 2
                  ? _c("div", [
                      _c(
                        "p",
                        [
                          _c("span", [_vm._v("您的出发地点：")]),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.startCity,
                              callback: function ($$v) {
                                _vm.startCity = $$v
                              },
                              expression: "startCity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("span", [_vm._v("您的返回地点：")]),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.endCity,
                              callback: function ($$v) {
                                _vm.endCity = $$v
                              },
                              expression: "endCity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("span", [_vm._v("您的首站旅游目的地：")]),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.toFirstCity,
                              callback: function ($$v) {
                                _vm.toFirstCity = $$v
                              },
                              expression: "toFirstCity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("span", [_vm._v("您的尾站旅游目的地：")]),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.toLastCity,
                              callback: function ($$v) {
                                _vm.toLastCity = $$v
                              },
                              expression: "toLastCity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        [
                          _c("span", [_vm._v("您行程中想经过的国家和城市：")]),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.routeCity,
                              callback: function ($$v) {
                                _vm.routeCity = $$v
                              },
                              expression: "routeCity",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.createtripAlertState = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.createTrip },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.planCreateType == 2 ? "请给我答案" : "确 定"
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.planCreateType == 1
            ? _c(
                "div",
                { staticClass: "customManually" },
                [
                  _c(
                    "p",
                    { staticStyle: { "margin-top": "20px" } },
                    [
                      _c("span", [_vm._v("预估人数：")]),
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          maxlength: "5",
                          onkeyup: "value=value.replace(/[^\\d]/g,'')",
                          size: "small",
                          placeholder: "请输入预估人数",
                        },
                        model: {
                          value: _vm.useNumber,
                          callback: function ($$v) {
                            _vm.useNumber = $$v
                          },
                          expression: "useNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      staticStyle: { "margin-top": "20px" },
                      attrs: {
                        action: "#",
                        "on-preview": _vm.handlePreview,
                        "on-remove": _vm.handleRemove,
                        "on-change": _vm.changeFile,
                        "file-list": _vm.fileList,
                        "auto-upload": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "trigger", type: "primary" },
                          slot: "trigger",
                        },
                        [
                          _vm._v("上传"),
                          _c("i", {
                            staticClass: "el-icon-upload el-icon--right",
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v("只能上传doc/docx文件，且不超过30M")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.createtripAlertState = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.customCreateTrip },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("DialogMobileChat", {
        ref: "mobileChat",
        on: {
          successfullyGenerated: function ($event) {
            _vm.createtripAlertState = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }